var exports = {
  "container": "x28a7bf27--902a51--container",
  "header": "x28a7bf27--902a51--header",
  "row": "x28a7bf27--902a51--row",
  "info-cell": "x28a7bf27--902a51--info-cell",
  "name": "x28a7bf27--902a51--name",
  "icon": "x28a7bf27--902a51--icon",
  "far-icon": "x28a7bf27--902a51--far-icon",
  "base-icon": "x28a7bf27--902a51--base-icon",
  "family-icon": "x28a7bf27--902a51--family-icon",
  "preferential-icon": "x28a7bf27--902a51--preferential-icon",
  "country-icon": "x28a7bf27--902a51--country-icon",
  "it-icon": "x28a7bf27--902a51--it-icon",
};

module.exports = exports;
